import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";

import SmartChartExportsList from "./SmartChartExportsList";
import Properties from "../properties/index";
import { SMART_CHART_TAB_VIEWS, SMART_CHART_FAVORITE_TAB_VIEWS, SMART_CHART_REPORT_VIEW } from "../constants";
import Documents from "./Documents";
import SmartChartDataEditForm from "./SmartChartDataEditForm";
import { useSelector } from "react-redux";
import Portal from "../../common/components/Portal";
import ReactTooltip from "react-tooltip";
import TaskManager from "./TaskManager";
import { checkPermission } from "../../../config/utils";
import { permissions } from "../../../config/permissions";
import StarIcon from "../../../assets/img/star.svg";
import StarActiveIcon from "../../../assets/img/star-active.svg";

const SmartChartMain = ({
    history,
    smartChartTableData,
    showWildCardFilter,
    paginationParams,
    currentViewAllUsers,
    showViewModal,
    tableData,
    handleGlobalSearch,
    toggleWildCardFilter,
    updateCurrentViewAllUsers,
    handleDeleteSite,
    showEditPage,
    handlePerPageChange,
    handlePageClick,
    showAddForm,
    updateSelectedRow,
    selectedRowId,
    globalSearchKey,
    match: {
        params: { section }
    },
    showInfoPage,
    updateWildCardFilter,
    wildCardFilter,
    handleHideColumn,
    getListForCommonFilterSite,
    updateCommonFilter,
    commonFilter,
    resetAllFilters,
    isColunmVisibleChanged,
    resetAll,
    updateTableSortFilters,
    resetSort,
    tableParams,
    exportSiteTable,
    showAddButton,
    hasExport,
    hasEdit,
    hasDelete,
    hasOwnDelete,
    hasInfoPage,
    entity,
    hasActionColumn,
    handleDownloadItem,
    refreshTableData,
    deleteSmartChartReport,
    regenerateSmartChart,
    showSmartChartDataEditModal,
    getSmartChartMasterFilterDropDown,
    masterFilterList,
    mFilters,
    updateMfilterForSmartChartList,
    handleClickTab,
    viewSmartChartProperty,
    handleEditSmartChartProperty,
    handleExportSmartReport,
    updateFiltersForMasterFilter,
    isModalView = false,
    viewReports,
    toggleSelectDownloadTypeModal,
    addToFavorite,
    isFavoriteView,
    handleSortData,
    handleSelectViewType,
    sortParams,
    viewType,
    toggleAssignUsersToFavoriteModal,
    toggleCreateReportFromCoreReportModal,
    selectedTabForFavoriteView,
    path,
    tableConfig,
    setUpdateCoreReport,
    setUpdateState,
    handleExportSmartReports,
    setShowDashboardSmartChartExport,
    isReportView = false,
    isGeoHierarchyReports=false,
    isBuildingReport = false,
    isConnectedReport = false,
    handleDateFilterChange,
    date_filter,
    reportTabBookmarks,
    isReportTabBookmarked,
    toggleReportTabBookmark,
    ...props
}) => {
    useEffect(() => {
        let previousProperty = sessionStorage.getItem("selectedProperty") || null;
        if (section === "reports" && previousProperty && !isModalView) {
            viewSmartChartProperty(previousProperty);
            sessionStorage.removeItem("selectedProperty");
        }
    }, [section]);
    let isSuperAdmin = localStorage.getItem("role") === "super_admin";
    const baseTabs = isFavoriteView ? SMART_CHART_FAVORITE_TAB_VIEWS : isReportView ? SMART_CHART_REPORT_VIEW : SMART_CHART_TAB_VIEWS;
    const tabViews = baseTabs.filter(tab => (tab?.permissionKey ? checkPermission("forms", tab.permissionKey, "view") : true));
    let currentSection = isFavoriteView || isReportView ? selectedTabForFavoriteView : section;
    const { filterValues } = useSelector(state => state?.dashboardReducer);

    const checkTaskManagerAccess = (isSuperAdmin, permissions) => {
        return isSuperAdmin || checkPermission("forms", permissions.SMART_CHART_TASK_MANAGER, "view");
    };
    const renderTabBookmark = tabView => {
        if (!reportTabBookmarks?.[tabView.key] || !toggleReportTabBookmark) return null;
        const isBookmarked = isReportTabBookmarked?.(tabView.key);
        return (
            <button
                type="button"
                className="btn p-0 not-draggable"
                data-tip={isBookmarked ? "Remove this Tab From Dashboard Bookmarks" : "Add this Tab to Dashboard Bookmarks"}
                data-for="report-tab-bookmark"
                onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleReportTabBookmark(tabView.key);
                }}
                style={{
                    alignItems: "center",
                    display: "inline-flex",
                    height: "14px",
                    justifyContent: "center",
                    lineHeight: 1,
                    marginLeft: "5px",
                    verticalAlign: "middle",
                    width: "14px"
                }}
            >
                <img
                    src={isBookmarked ? StarActiveIcon : StarIcon}
                    alt={isBookmarked ? "Remove from Bookmarks" : "Add to Bookmarks"}
                    style={{ display: "block", width: "11px", height: "11px" }}
                />
            </button>
        );
    };
    return (
        <React.Fragment>
            <div
                className={`dtl-sec col-md-12 ${isFavoriteView || isModalView ? "height-full" : ""} padd-report ${
                    !currentSection || currentSection === "corereports" ? "view-pad" : ""
                } ${isConnectedReport ? "conntdRptTooltip" : ""}`}
            >
                <div className="tab-dtl region-mng smchart-exp top-smrt-exp">
                    {!isGeoHierarchyReports && (
                        <div className="d-flex justify-content-between align-items-center">
                            {isFavoriteView || !isModalView || isReportView ? (
                                <>
                                    <ReactTooltip id="report-tab-bookmark" place="bottom" effect="solid" backgroundColor="#007bff" />
                                    <ul className={`tab-data`}>
                                        {tabViews
                                            ?.filter(item => !item?.isButtonTab)
                                            ?.filter(item => {
                                                if (item?.key === "taskmanager" && !checkTaskManagerAccess(isSuperAdmin, permissions)) {
                                                    return false;
                                                }
                                                return true;
                                            })

                                            ?.map((tabView, index) => (
                                                <li
                                                    key={index}
                                                    className={`cursor-pointer ${currentSection === tabView.key ? "active" : ""}`}
                                                    onClick={() => handleClickTab(tabView, isFavoriteView || isReportView)}
                                                >
                                                    <span className="d-inline-flex align-items-center">
                                                        <span>{tabView.label}</span>
                                                        {renderTabBookmark(tabView)}
                                                    </span>
                                                </li>
                                            ))}
                                    </ul>

                                    <div class="sm-chart-btn">
                                        {tabViews
                                            ?.filter(item => item?.isButtonTab)
                                            ?.map((tabView, index) => (
                                                <button
                                                    key={tabView.key}
                                                    onClick={() => handleClickTab(tabView, isFavoriteView || isReportView)}
                                                    class={`btn ${tabView.class} ${currentSection === tabView.key ? "active-smrt-btn" : ""} `}
                                                >
                                                    <span class="icon mr-1">
                                                        <img src={tabView.icon} alt="" />
                                                    </span>
                                                    <span class="text">{tabView.label}</span>
                                                </button>
                                            ))}
                                    </div>
                                </>
                            ) : null}
                            {path === "/dashboard" && checkPermission("forms", permissions.SMART_CHARTS, "export") && (
                                <button
                                    type="button"
                                    className="icon-bg-outr btnText exp-butn"
                                    data-tip={`Generate Report For Current Dashboard`}
                                    data-for="smart-chart"
                                    onClick={e => {
                                        e.preventDefault();
                                        setShowDashboardSmartChartExport(true);
                                    }}
                                    disabled={filterValues?.client_ids?.length > 1 || filterValues?.project_ids?.length > 1}
                                >
                                    <img src="/img/export.svg" /> Dashboard Report
                                </button>
                            )}
                            <ReactTooltip id="smart-chart" place="left" effect="solid" backgroundColor="#007bff" />
                        </div>
                    )}
                    {(currentSection === "reporttemplates" && !isModalView) || (currentSection === "reporttemplates" && path === "/dashboard") ? (
                        <Properties
                            // viewSmartChartProperty={viewSmartChartProperty}
                            handleEditSmartChartProperty={handleEditSmartChartProperty}
                            handleExportSmartReport={handleExportSmartReport}
                            updateFiltersForMasterFilter={updateFiltersForMasterFilter}
                            savedParams={mFilters}
                            showSmartChartDataEditModal={showSmartChartDataEditModal}
                            viewReports={viewReports}
                        />
                    ) : currentSection === "documents" && !isModalView ? (
                        <>
                            <Documents
                                getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                                updateMfilterForSmartChartList={updateMfilterForSmartChartList}
                                updateFiltersForMasterFilter={updateFiltersForMasterFilter}
                                savedParams={mFilters}
                            />
                        </>
                    ) : currentSection === "images" && !isModalView ? (
                        <Documents
                            isImage
                            getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                            updateMfilterForSmartChartList={updateMfilterForSmartChartList}
                            updateFiltersForMasterFilter={updateFiltersForMasterFilter}
                            savedParams={mFilters}
                        />
                    ) : (currentSection === "corereports" && !isModalView) ||
                      (currentSection === "corereports" && path === "/dashboard") ||
                      (currentSection === "corereports" && isReportView) ? (
                        <>
                            <Properties
                                // viewSmartChartProperty={viewSmartChartProperty}
                                handleEditSmartChartProperty={handleEditSmartChartProperty}
                                handleExportSmartReport={handleExportSmartReport}
                                updateFiltersForMasterFilter={updateFiltersForMasterFilter}
                                savedParams={mFilters}
                                showSmartChartDataEditModal={showSmartChartDataEditModal}
                                viewReports={viewReports}
                                isSkeletonView
                                toggleCreateReportFromCoreReportModal={toggleCreateReportFromCoreReportModal}
                                isModalView={isModalView}
                                setUpdateCoreReport={setUpdateCoreReport}
                                currentSection={currentSection}
                                setUpdateState={setUpdateState}
                                isReportView={isReportView}
                            />
                        </>
                    ) : currentSection === "taskmanager" &&
                      (isSuperAdmin ||
                          (checkPermission("forms", permissions.SMART_CHART_TASK_MANAGER, "view") && (!isModalView || path === "/dashboard"))) ? (
                        <>
                            <TaskManager
                                getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                                masterFilterList={masterFilterList}
                                mFilters={mFilters}
                                updateMfilterForSmartChartList={updateMfilterForSmartChartList}
                                isModalView={isModalView}
                                resetAllFilters={resetAllFilters}
                            />
                        </>
                    ) : (
                        <SmartChartExportsList
                            getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                            masterFilterList={masterFilterList}
                            mFilters={mFilters}
                            updateMfilterForSmartChartList={updateMfilterForSmartChartList}
                            paginationParams={paginationParams}
                            handlePageClick={handlePageClick}
                            handlePerPageChange={handlePerPageChange}
                            tableData={tableData}
                            hasEdit={hasEdit}
                            showAddButton={showAddButton}
                            refreshTableData={refreshTableData}
                            handleGlobalSearch={handleGlobalSearch}
                            globalSearchKey={globalSearchKey}
                            hasExport={hasExport}
                            hasDelete={hasDelete}
                            hasOwnDelete={hasOwnDelete}
                            resetAllFilters={resetAllFilters}
                            showSmartChartDataEditModal={showSmartChartDataEditModal}
                            regenerateSmartChart={regenerateSmartChart}
                            deleteSmartChartReport={deleteSmartChartReport}
                            handleDownloadItem={handleDownloadItem}
                            showWildCardFilter={showWildCardFilter}
                            showEditPage={showEditPage}
                            showInfoPage={showInfoPage}
                            updateSelectedRow={updateSelectedRow}
                            selectedRowId={selectedRowId}
                            updateWildCardFilter={updateWildCardFilter}
                            wildCardFilter={wildCardFilter}
                            handleHideColumn={handleHideColumn}
                            getListForCommonFilter={getListForCommonFilterSite}
                            updateCommonFilter={updateCommonFilter}
                            commonFilter={commonFilter}
                            updateTableSortFilters={updateTableSortFilters}
                            tableParams={tableParams}
                            permissions={permissions}
                            hasInfoPage={hasInfoPage}
                            hasActionColumn={hasActionColumn}
                            viewSmartChartProperty={viewSmartChartProperty}
                            handleEditSmartChartProperty={handleEditSmartChartProperty}
                            isModalView={isModalView}
                            toggleSelectDownloadTypeModal={toggleSelectDownloadTypeModal}
                            addToFavorite={addToFavorite}
                            isFavoriteView={isFavoriteView}
                            handleSortData={handleSortData}
                            handleSelectViewType={handleSelectViewType}
                            sortParams={sortParams}
                            viewType={viewType}
                            toggleAssignUsersToFavoriteModal={toggleAssignUsersToFavoriteModal}
                            isGeoHierarchyReports={isGeoHierarchyReports}
                            handleDateFilterChange={handleDateFilterChange}
                            date_filter={date_filter}
                            currentSection={currentSection}
                        />
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default withRouter(SmartChartMain);
